import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { generateEntity } from 'src/shared/entities/utils/generate-base-entity'
import { WebsiteLanguageSwitcherInterface } from 'src/shared/types/entities/website-language-switcher-interface'

export const createWebsiteLanguageSwitcher = (
  parentId: string,
): WebsiteLanguageSwitcherInterface => {
  const entity: WebsiteLanguageSwitcherInterface = {
    ...generateEntity(EntityTypeEnum.WebsiteLanguageSwitcher, parentId),
    type: EntityTypeEnum.WebsiteLanguageSwitcher,
    excludedLanguages: [],
  }
  return entity
}
